module.exports = __webpack_public_path__ + "static/media/3-iron.2b517ee8.png";